import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../utils/APIS";
import { IDS } from "../utils/IDS";
import { GET, POST, PUT } from "../utils/Methods";

export const Getprofile = createAsyncThunk(
  "profile/get",
  async (_, thunkAPI) => {
    try {
      const res = await GET(APIS.Auth.getprofile, {
        credentials: "include",
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "Something went wrong");
    }
  },
);

export const editprofile = createAsyncThunk(
  "masters/editprofile/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Auth.updateprofile}/${id}`, data, {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const payload = res?.data?.success !== undefined ? res.data : res;
      if (payload.success) {
        return payload; //
      } else {
        return rejectWithValue(payload);
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const GetAllReport = createAsyncThunk(
  "profile/get-all-report",
  async (_, thunkAPI) => {
    try {
      const res = await GET(APIS.Auth.getAllReport, {
        credentials: "include",
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "Something went wrong");
    }
  },
);

export const Slice = createSlice({
  name: "contain",
  initialState: {
    getprofile: {},
    updateprofile: {},
    getReportData: {},
    status: null,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder

      // GET PROFILE
      .addCase(Getprofile.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Getprofile.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.getprofile = action.payload || {};
      })
      .addCase(Getprofile.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // UPDATE PROFILE
      .addCase(editprofile.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(editprofile.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.updateprofile = action.payload || {};
      })
      .addCase(editprofile.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllReport.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllReport.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.getReportData = action.payload || {};
      })
      .addCase(GetAllReport.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
